import styled from "styled-components";

interface Props {
  width: string;
  height: string;
  fit?: "contain" | "cover";
}

export const Image = styled.img<Props>`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  max-width: 100%;
  object-fit: ${(props) => (props.fit ? props.fit : "cover")};
`;
